import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TipoUsuario } from "../model/usuario";

@Pipe({
  name: "usuarioTipo",
  standalone: true
})
export class UsuarioTipoPipe implements PipeTransform {

    constructor(private translate: TranslateService) { }

    transform(value: TipoUsuario, args?: any): any {
        
        switch (value) {
            case TipoUsuario.Administrador:
                return this.translate.instant('header.usuarioTipo.administrador');
            case TipoUsuario.Suporte:
                return this.translate.instant('header.usuarioTipo.suporte');
            case TipoUsuario.OwnerConta:
                return this.translate.instant('header.usuarioTipo.ownerConta');
            case TipoUsuario.Gestor:
                return this.translate.instant('header.usuarioTipo.gestor');
            case TipoUsuario.Operador:
                return this.translate.instant('header.usuarioTipo.operador');
            case TipoUsuario.ApiKey:
                return this.translate.instant('header.usuarioTipo.apiKey');
            case TipoUsuario.EpbxManager:
                return this.translate.instant('header.usuarioTipo.epbxManager');
            case TipoUsuario.Okta:
                return this.translate.instant('header.usuarioTipo.okta');
            default:
                return '';
        }
    }
}